import { SPATIAL_ANALYSIS_SHOW_MODAL, SPATIAL_ANALYSIS_HIDE_MODAL } from './mutations.type.js';

export const state = {
  visible: false
}

export const mutations = {
  [SPATIAL_ANALYSIS_SHOW_MODAL]() {
    if (!state.visible) {
      state.visible = true;
    }
  },
  [SPATIAL_ANALYSIS_HIDE_MODAL]() {
    state.visible = false;
  }
}

export const getters = {
  spatialAnalysisModalVisible() {
    return state.visible;
  }
}

export default { 
  state,
  mutations,
  getters
}